import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { resetPassword } from '../services/apiService'; // Yeni API fonksiyonumuzu import ediyoruz

export default function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { resetToken } = useParams(); // URL'den token'ı alıyoruz
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== passwordConfirm) {
      setError('Girdiğiniz şifreler eşleşmiyor.');
      return;
    }
    if (password.length < 8) {
        setError('Şifreniz en az 8 karakter olmalıdır.');
        return;
    }

    setLoading(true);
    try {
      const data = await resetPassword(resetToken, password, passwordConfirm);
      setMessage(data.message || 'Şifreniz başarıyla güncellendi! Şimdi giriş yapabilirsiniz.');
      
      // Başarılı olduktan 3 saniye sonra giriş sayfasına yönlendir
      setTimeout(() => {
        navigate('/owner/login');
      }, 3000);

    } catch (err) {
      setError(err.message || 'Bir hata oluştu. Linkin süresi dolmuş veya geçersiz olabilir.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-rose-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-3 group">
            <span className="size-12 rounded-2xl bg-rose-500/10 grid place-items-center ring-1 ring-rose-200/50">
              <Heart className="w-6 h-6 text-rose-600" />
            </span>
            <span className="font-semibold tracking-tight text-3xl text-gray-800">
               <span className="text-rose-600">Anora</span>
            </span>
          </Link>
          <h1 className="mt-4 text-2xl font-bold text-gray-700">Yeni Şifre Belirle</h1>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border border-rose-100">
          {message ? (
            <div className="text-center text-green-700 bg-green-100 p-4 rounded-md">
              <p>{message}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="password"className="block text-sm font-medium text-gray-700">Yeni Şifre</label>
                <input
                  id="password"
                  type="password"
                  className="mt-1 w-full p-3 border border-gray-300 rounded-md focus:ring-rose-500 focus:border-rose-500"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="passwordConfirm" className="block text-sm font-medium text-gray-700">Yeni Şifre (Tekrar)</label>
                <input
                  id="passwordConfirm"
                  type="password"
                  className="mt-1 w-full p-3 border border-gray-300 rounded-md focus:ring-rose-500 focus:border-rose-500"
                  placeholder="••••••••"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  required
                />
              </div>

              {error && <div className="text-sm text-red-600 bg-red-100 p-3 rounded-md">{error}</div>}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-rose-600 text-white font-bold py-3 px-4 rounded-md hover:bg-rose-700 disabled:bg-rose-300 transition-colors"
              >
                {loading ? 'Güncelleniyor…' : 'Şifreyi Güncelle'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
